import { useEffect } from 'react';

import { createStateSelectorHook } from 'src/lib/sweetState';
import { PerformanceStore, usePerformanceActions, useCurrentWorkspaceId } from 'src/store';
import { captureMessage } from 'src/utils/lib/sentry';
import { RESOURCES } from 'src/data/performance';

const usePerformanceState = createStateSelectorHook(PerformanceStore, ['connectedAccountsFetched']);

export const useGetResourcesLastExtraction = () => {
  const currentWorkspaceId = useCurrentWorkspaceId();
  const performanceActions = usePerformanceActions();
  const { connectedAccountsFetched } = usePerformanceState();

  useEffect(() => {
    if (!connectedAccountsFetched) {
      return;
    }

    RESOURCES.forEach((channel) => {
      if (performanceActions.getChannelExtractingCopies(channel)) {
        return;
      }

      performanceActions.getChannelLastExtraction(channel).catch((error) => {
        captureMessage('Error getting channel last extraction', {
          level: 'warning',
          extra: {
            error: error.toString(),
            source: 'useGetResourcesLastExtraction',
          },
        });
      });
    });
  }, [connectedAccountsFetched, performanceActions, currentWorkspaceId]);
};
